import { useState, useEffect } from "react";
import React from 'react';
import {  useLoaderData, redirect, useRevalidator  } from 'react-router-dom';

import { getOrdersPending, getLabConfig } from '../utils/api';
import PendingOrderItem from '../components/Order/PendingOrderItem';

import TestInfoClasses from '../components/Tests/TestInfo.module.css';

const OrderHistory = (props) => {
	const OrderHistory=useLoaderData();

		const [PPURL, setPPURL] = useState([]);
		useEffect(() => {
			async function fetchPortalTitle() {
				let PPURL2="http://localhost:3001";
				if (process.env.NODE_ENV === 'production') {
					 PPURL2 = await getLabConfig("PPWEBSERVER");
				}
				console.log(PPURL2);
				setPPURL(PPURL2);
			}
			fetchPortalTitle();
		}, []);
		const [webURL, setWebURL] = useState([]);
		useEffect(() => {
			async function fetchLabSetting() {
				const webURL = await getLabConfig('WEBSERVER');
				setWebURL(webURL);
			}
			fetchLabSetting();
		}, [])
		const [scheduleHub,setScheduleHub] = useState('0');
		useEffect(() => {
			(async () => {
			  const sched = await getLabConfig("SCHEDULEHUB");
			  setScheduleHub(sched);
			})();
		  }, []);	

		const revalidator = useRevalidator();

		useEffect(() => {
			const onVisible = () => {
			  if (document.visibilityState === "visible") {
				revalidator.revalidate();
			  }
			};

			document.addEventListener("visibilitychange", onVisible);
			return () =>
			  document.removeEventListener("visibilitychange", onVisible);
		}, [revalidator]);

    return( 
    		<div className={TestInfoClasses.testInfo}>
	    	<div className={TestInfoClasses.testInfoContent}>
	    		<h2 className={TestInfoClasses.testTitle} >Order History</h2>
	    		
			<table className={TestInfoClasses.inboxReport}>
				<thead><tr><th>Ordered Date</th><th>Test(s) Ordered</th><th/><th>Order Number</th><th>Status</th></tr></thead>
				<tbody>
				{console.log("PPURL",PPURL)}
			{OrderHistory === 'no pending orders' ? (
				  <p>No data available.</p>
				) : (
				  OrderHistory.map((item) => {
					  return (
						<PendingOrderItem
						  key={item.reqNumber}
						  item={{
							name: item.displaycodes,
							disReqNum: item.disReqNum,
							orderDT: item.DateOrdered,
							releasedRaw: item.Released,
							reqNumber: item.ReqNumber,
							pending: item.Pending,
							reqTests: item?.ReqTestsID,
							destlab: item.lab,
							status: item.Status,
							PPURL: PPURL,
							webURL: webURL,
							scheduleHub: scheduleHub,
							apptTime: item.apptTime,
							apptLocation: item.apptLocation
						  }}
						/>
					  );
					})
			)}

			</tbody></table>
		</div>
	</div>
	);
};

export default OrderHistory;

export async function loader() {
    const response = await getOrdersPending();
	const resData = await response;
		if (resData.length) {
			console.log(resData);
			return resData;
		}else{
			return redirect('/Login');
		}
}

